import { render, staticRenderFns } from "./MmaProdesBiomas.vue?vue&type=template&id=4d334cad&lang=pug"
import script from "./MmaProdesBiomas.vue?vue&type=script&lang=js"
export * from "./MmaProdesBiomas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports